import React from 'react';
import { Link } from 'wouter';

import styles from './footer-link.module.scss';

export function FooterLink({ text, href, highlight = false }) {
    return (
        <Link href={href} className={styles.footer_link}>
            {text}
            {highlight && <span className={styles.new_label}>New</span>}
        </Link>
    );
}
